// Mobile Accordion Navigation - Simple, stable accordion for mobile only
(function() {
  'use strict';

  function isMobile() {
    return window.innerWidth <= 749;
  }

  const animating = new WeakMap();

  function initMobileAccordion() {
    
    if (!isMobile()) {
      const menuItems = document.querySelectorAll(
        '.new-header-nav__left .menu-list__list-item, ' +
        '.new-header-nav .menu-list__list-item'
      );
      menuItems.forEach(function(item) {
        const link = item.querySelector('.menu-list__link[aria-haspopup="true"]');
        if (link && link._accordionObserver) {
          link._accordionObserver.disconnect();
          link._accordionObserver = null;
        }
      });
      return;
    }


    const menuItems = document.querySelectorAll(
      '.new-header-nav__left .menu-list__list-item, ' +
      '.new-header-nav .menu-list__list-item, ' +
      '.header .menu-list__list-item, ' +
      'header-component .menu-list__list-item'
    );


    menuItems.forEach(function(item) {
      const link = item.querySelector('.menu-list__link[aria-haspopup="true"]');
      if (!link) return;

      const submenu = item.querySelector('.menu-list__submenu');
      if (!submenu) return;

      if (link._accordionInitialized) return;
      link._accordionInitialized = true;

      link._accordionSubmenu = submenu;
      link._accordionItem = item;

      submenu.style.display = 'none';
      submenu.style.visibility = 'hidden';
      submenu.style.maxHeight = '0px';
      submenu.style.opacity = '0';
      submenu.style.overflow = 'hidden';
      submenu.style.transition = 'max-height 0.25s ease-out, opacity 0.25s ease-out';
      submenu.style.position = 'static';

      function handleAccordionClick(event) {

        if (!isMobile()) {
          return;
        }


        event.stopImmediatePropagation();

        if (animating.get(submenu)) return;
        animating.set(submenu, true);

        const isExpanded = link.getAttribute('aria-expanded') === 'true';
        const newExpanded = !isExpanded;

        link.setAttribute('aria-expanded', newExpanded ? 'true' : 'false');
        item.setAttribute('aria-expanded', newExpanded ? 'true' : 'false');

        if (newExpanded) {
          
          submenu.style.display = 'block';
          submenu.style.visibility = 'visible';
          submenu.style.overflow = 'hidden';
          submenu.style.position = 'static';
          
          const height = submenu.scrollHeight;
          
          submenu.style.maxHeight = '0px';
          submenu.style.opacity = '0';
          
          void submenu.offsetHeight;
          
          requestAnimationFrame(function() {
            submenu.style.maxHeight = height + 'px';
            submenu.style.opacity = '1';
          });

          setTimeout(function() {
            submenu.style.maxHeight = 'none';
            submenu.style.overflow = 'visible';
            animating.set(submenu, false);
          }, 250);
        } else {
          
          const height = submenu.scrollHeight;
          submenu.style.maxHeight = height + 'px';
          submenu.style.overflow = 'hidden';
          
          void submenu.offsetHeight;
          
          requestAnimationFrame(function() {
            submenu.style.maxHeight = '0px';
            submenu.style.opacity = '0';
          });

          setTimeout(function() {
            submenu.style.display = 'none';
            submenu.style.visibility = 'hidden';
            animating.set(submenu, false);
          }, 250);
        }
      }

      link.addEventListener('click', handleAccordionClick, {
        capture: true,
        passive: false
      });

      link._accordionClickHandler = handleAccordionClick;
    });
  }

  function safeInit() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMobileAccordion, { once: true });
    } else {
      initMobileAccordion();
    }
  }

  safeInit();

  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      const menuItems = document.querySelectorAll(
        '.new-header-nav__left .menu-list__list-item, ' +
        '.new-header-nav .menu-list__list-item'
      );
      menuItems.forEach(function(item) {
        const link = item.querySelector('.menu-list__link[aria-haspopup="true"]');
        if (link) {
          if (link._accordionClickHandler) {
            link.removeEventListener('click', link._accordionClickHandler, true);
            link._accordionClickHandler = null;
          }
          link._accordionInitialized = false;
        }
      });
      initMobileAccordion();
    }, 300);
  });
})();
